const VAS_NAMES: { [index: string]: string } = {
  auction: 'Аукцион',
  colorized: '',
  payed: 'Платное',
  premium: 'Премиум',
  top3: 'Топ 3',
};

const ML_VAS_NAMES: { [index: string]: string } = {
  auction: 'Аукцион',
  colorized: '',
  payed: 'Платное',
  premium: 'Премиум',
  top3: 'Топ',
};

const FULL_VAS_NAMES: { [index: string]: string } = {
  auction: 'Аукцион',
  colorized: 'Выделение цветом',
  payed: 'Платное',
  premium: 'Премиум',
  top3: 'Топ 3',
};

const ML_FULL_VAS_NAMES: { [index: string]: string } = {
  auction: 'Аукцион',
  colorized: 'Выделение цветом',
  payed: 'Платное',
  premium: 'Премиум',
  top3: 'Топ',
};

// Отключил в этом объекте длину строки, чтобы не извращаться с переносом строк
// tslint:disable:max-line-length
const VAS_DESCRIPTIONS: { [index: string]: string } = {
  auction: 'Объявления пользователей, которые заплатили больше, показываются на более высоких позициях.',
  colorized: 'Яркий жёлтый фон выделит ваше объявление на фоне других.',
  payed: 'Объявления будут показаны после Топ-объявлений и всех Премиумов.',
  premium: 'Объявления показываются сразу под Топ-объявлениями, но перед Платными.',
  top3: 'Объявления занимают первые три позиции на странице результатов поиска. Можно добавить к объявлению свой логотип.',
};

const ML_VAS_DESCRIPTIONS: { [index: string]: string } = {
  auction:
    'Аукцион – это способ увеличить частоту показов вашего объявления. Чем выше ставка, тем чаще ваше объявление будет показано в результатах поиска.',
  colorized: 'Ваше объявление будет выделено ярким цветом на фоне других объявлений.',
  payed:
    'Платные объявления никак не выделяются в результатах поиска и показываются в 3 раза реже, чем Топ-объявления.',
  premium:
    'Премиум-объявления выделены в результатах поиска за счёт дополнительных фотографий. Такие объявления показываются в 1.5 раза чаще обычных.',
  top3: 'Топ-объявления самые заметные в результатах поиска за счёт больших фотографий и брендирования. Такие объявления показываются в 3 раза чаще обычных.',
};
// tslint:enable:max-line-length

/**
 * Возвращает имя VAS с самым высоким приоритетом
 * @param vasList список VAS'ов объявления, отсортированный по приоритету
 */
export function getTopVasName(vasList: string[]) {
  return VAS_NAMES[vasList[0]];
}

/**
 * Возвращает имя VAS по заданной мнемонике (например, premium => Премиум)
 * @param vas мнемоника VAS
 * @param useFullNames указывать на необходимость возвращать полные имена всех VAS
 */
export function getVasName(vas: string, useFullNames: boolean) {
  return useFullNames ? FULL_VAS_NAMES[vas] : VAS_NAMES[vas];
}

/**
 * Возвращает описание VAS и его преимущества
 * @param vas мнемоника VAS
 */
export function getVasDescription(vas: string) {
  return VAS_DESCRIPTIONS[vas];
}

/**
 * Возвращает имя VAS с самым высоким приоритетом (с учетом ранжированной выдачи)
 * @param vasList список VAS'ов объявления, отсортированный по приоритету
 */
export function getMlTopVasName(vasList: string[]) {
  return ML_VAS_NAMES[vasList[0]];
}

/**
 * Возвращает имя VAS по заданной мнемонике (с учетом ранжированной выдачи)
 * например, premium => Премиум
 * @param vas мнемоника VAS
 * @param useFullNames указывать на необходимость возвращать полные имена всех VAS
 */
export function getMlVasName(vas: string, useFullNames: boolean) {
  return useFullNames ? ML_FULL_VAS_NAMES[vas] : ML_VAS_NAMES[vas];
}

/**
 * Возвращает описание VAS и его преимущества (с учетом ранжированной выдачи)
 * @param vas мнемоника VAS
 */
export function getMlVasDescription(vas: string) {
  return ML_VAS_DESCRIPTIONS[vas];
}
